export default __webpack_public_path__ + "static/media/copy.b25cdacc.svg";